import { render, staticRenderFns } from "./baseCfg.vue?vue&type=template&id=56d12360&scoped=true&"
import script from "./baseCfg.vue?vue&type=script&lang=js&"
export * from "./baseCfg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d12360",
  null
  
)

export default component.exports